// Any config specific to UAE?

export default {
  code: 'AE',
  countryName: 'UAE',
  // googleSiteVerificationCode: '1uUi471agIlOfQQ3ns5BSv78-YAYOVbuPdRyGUsfq2I',
  googleSiteVerificationCode: [
    'X1B_9GgrzG2rdOXBoOKgIif4kvi8_HixLZ0Ouh6Hd3E',
    'JFFoWxQKmqhrAuhB-IB2BqGvVcS3wLFkI0k_ngI_HPE',
    'dVeifo7x_okBPnD948tdrt96OO6tEJWYuLcbnCZfI-E'
  ],
  countryDomain: 'https://www.carrefouruae.com',
  helplineNumber: '800 73232',
  latitude: 25.2171003,
  longitude: 55.3613635,
  countryFlagIcon: 'AE_3cd82801fe.png',
  defaultAreaCode: 'Dubai Festival City - Dubai',
  features: {
    languageChange: true,
    now: true,
    share: true,
    isLocationCXEnable: true,
    isNewAddress: false,
    cashback: false,
    linkMyClubCard: false,
    oneTrustScript: 'f040c17c-64a7-4541-a254-582dced0d07e',
    isExtraOneTrustScript: true
  },
  metaVerificationTag: 'a1a147c1c5'
}
